import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API from "../services/api";
import { getAllCategories } from "../services/resourceService";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [categories, setCategories] = useState([]);

  const closeMobileMenu = () => {
    const navbar = document.getElementById("navbarNav");
    if (navbar && navbar.classList.contains("show")) {
      const toggler = document.querySelector(".navbar-toggler");
      if (toggler) {
        toggler.click();
      }
    }
  };

  // Handle section click (supports both same-page smooth scroll and cross-page navigation)
  const handleNavClick = (e, id) => {
    e.preventDefault();
    if (window.location.pathname === "/") {
      if (id === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      if (id === "top") {
        navigate("/");
      } else {
        navigate("/", { state: { scrollTo: id } });
      }
    }
    closeMobileMenu();
  };

  useEffect(() => {
    async function fetchCategories() {
      try {
        const data = await getAllCategories();
        if (data && data.length > 0) {
          setCategories(data);
        }
      } catch (error) {
        console.error("Failed to fetch categories for Header dropdown:", error);
      }
    }
    fetchCategories();
  }, []);

  const filteredCategories = categories.filter(
    (category) => category !== "CNNS" && category !== "Policy Briefs and Field Stories"
  );

  const navigate = useNavigate();

  return (
    <header className="header-container">
      <div className="container-fluid px-lg-5 position-relative">
        <div className="row align-items-center py-2">
          {/* Left Logos */}
          <div className="col-lg-3 col-md-6 col-8 d-flex align-items-center">

            <img
              src="/Images/AMB.svg"
              alt="Anemia Mukt Bharat"
              className="left-logo"
              onClick={() => {
                if (window.location.pathname === "/") {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                } else {
                  navigate("/");
                }
              }}
              style={{ cursor: "pointer" }}
            />
            <img
              src="/Images/Nhm.svg"
              alt="National Health Mission"
              className="left-logo ms-3"
            />
          </div>

          {/* Center Logo */}
          <div className="col-lg-3 d-none d-lg-block">
            <div className="emblem-wrapper d-none d-lg-flex">
              <img
                src="/Images/Amblem.svg"
                alt="MOHFW"
                className="center-logo"
              />
            </div>
          </div>

          {/* Right Navigation */}
          <div className="col-lg-6 col-md-6 col-4">
            <nav className="navbar navbar-expand-lg p-0 position-relative">
              <button
                className="navbar-toggler ms-auto"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                <ul className="navbar-nav ms-auto align-items-lg-center">
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={(e) => handleNavClick(e, 'top')}>HOME</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={(e) => handleNavClick(e, 'about')}>ABOUT</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={(e) => handleNavClick(e, 'beneficiaries')}>BENEFICIARIES</a>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="resourceDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      RESOURCE
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="resourceDropdown">
                      {filteredCategories.map((category) => (
                        <li key={category}>
                          <Link className="dropdown-item" to={`/resource?category=${encodeURIComponent(category)}`} onClick={closeMobileMenu}> {category}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={(e) => handleNavClick(e, 'gallery')}>GALLERY</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={(e) => handleNavClick(e, 'feedback')}>FEEDBACK</a>
                  </li>
                  <li className="nav-item ms-lg-3 mt-2 mt-lg-0">
                    <button className="btn login-btn" onClick={() => {
                      closeMobileMenu();
                      window.location.href = "https://ambabhiyaan.mohfw.gov.in/AMB/";
                    }}>
                      <i className="bi bi-box-arrow-in-right me-2"></i>
                      LOGIN
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
